import React, { useState } from 'react';
import TextArea from 'components/shared/debouncedTextArea';
import TryAgain from 'components/TryAgain';
import { Button, Spinner } from 'ui';
import Modal from 'ui/Modal';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import FeedbackSubmissionSuccess from './FeedbackSubmissionSuccess';

const ModalFeedbackForm = ({
  recipient,
  betaFeatureName,
  showModal,
  updateShowModal,
}) => {
  const [feedbackSubmissionSuccess, setFeedbackSubmissionSuccess] =
    useState(false);
  const [updatedFeedback, setUpdatedFeedback] = useState('');
  const [feedbackSubmissionFailed, setFeedbackSubmissionFailed] =
    useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFeedback = async () => {
    try {
      setIsSubmitting(true);
      await request
        .postJSON(routes.BETA_FEEDBACK, {
          recipient,
          feature_name: betaFeatureName,
          feedback: updatedFeedback,
        })
        .then(res => {
          if (res.success) {
            setFeedbackSubmissionSuccess(true);
            setFeedbackSubmissionFailed(false);
            setUpdatedFeedback('');
          } else {
            setFeedbackSubmissionFailed(true);
          }
          setIsSubmitting(false);
        });
    } catch (error) {
      setFeedbackSubmissionFailed(true);
      setIsSubmitting(false);
    }
  };

  const resetStateAndClose = () => {
    updateShowModal(false);
    setFeedbackSubmissionFailed(false);
    setFeedbackSubmissionSuccess(false);
    setFeedbackSubmissionFailed(false);
    setUpdatedFeedback('');
  };

  return (
    <Modal
      shown={showModal}
      onDismiss={resetStateAndClose}
      canClickAway
      className="w-35p Modal-shell"
      enableFloatingDismiss
    >
      <Modal.Content>
        <div>
          <div className="d-f fd-c">
            <Text variant={TEXT_VARIANTS.TITLE} className="mb-24">
              {t('beta_feedback.give_us_feedback')}
            </Text>
            {!feedbackSubmissionSuccess && (
              <Text
                variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
                className="mb-4"
              >
                {t('beta_feedback.subheader')}
              </Text>
            )}
          </div>
          {feedbackSubmissionSuccess ? (
            <FeedbackSubmissionSuccess
              resetStateAndClose={resetStateAndClose}
            />
          ) : (
            <div>
              <TextArea
                variant={TEXT_VARIANTS.BODY}
                placeholder={t('beta_feedback.placeholder')}
                className="Modal-input"
                onChange={value => setUpdatedFeedback(value)}
                disabled={isSubmitting}
              />

              {feedbackSubmissionFailed ? (
                <TryAgain
                  disabled={!updatedFeedback.trim()}
                  handleRetry={handleFeedback}
                />
              ) : (
                <div className="d-f jc-e mt-24">
                  <Button
                    type="button"
                    className="mr-8"
                    onClick={resetStateAndClose}
                  >
                    {t('common.cancel')}
                  </Button>
                  <Button
                    type="button"
                    customColor
                    onClick={handleFeedback}
                    disabled={isSubmitting || !updatedFeedback.trim()}
                  >
                    {isSubmitting && <Spinner className="mr-16" />}
                    {t('lesson_overview.submit_button')}
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default ModalFeedbackForm;
